import { render, staticRenderFns } from "./TermlyCheckbox.vue?vue&type=template&id=74a06db9&scoped=true"
import script from "./TermlyCheckbox.vue?vue&type=script&lang=js"
export * from "./TermlyCheckbox.vue?vue&type=script&lang=js"
import style0 from "./TermlyCheckbox.vue?vue&type=style&index=0&id=74a06db9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a06db9",
  null
  
)

export default component.exports